
import { NgModule } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
// componentes de terceros
import { BsDatepickerModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { TimeAgoPipe } from 'time-ago-pipe';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { UtilsModule } from './../../utils/utils.module';
// Detalles solicitud
import { DetalleComponent } from './cliente/detalle.component';
import { CommentscomponentComponent } from './commentscomponent/commentscomponent.component';
import { DetallehomeComponent } from './detallehome.component';
import { DetalledocoutComponent } from './docout/detalledocout.component';
import { HistoricocomponentComponent } from './historicocomponent/historicocomponent.component';
import { TablaContenidosComponent } from './tabla-contenidos/tabla-contenidos.component';
import { MotivosComponent } from './motivos/motivos.component';
import { RelacionesAlmacenComponent } from './relaciones-almacen/relaciones-almacen.component';
import { MenuimpresiondocumentosComponent } from '../../utils/menuimpresiondocumentos/menuimpresiondocumentos.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports:
    [
      NgxDatatableModule,
      UtilsModule,
      BsDatepickerModule,
      TabsModule.forRoot(),
      TooltipModule.forRoot(),
      OwlDateTimeModule,
      OwlNativeDateTimeModule,
      SharedModule,
      CoreModule
    ],
  declarations: [
    DetalleComponent,
    DetalledocoutComponent,
    DetallehomeComponent,
    CommentscomponentComponent,
    HistoricocomponentComponent,
    TimeAgoPipe,
    TablaContenidosComponent,
    MotivosComponent,
    RelacionesAlmacenComponent
  ],
  exports: [
    TablaContenidosComponent
  ],
  entryComponents: []
})
export class DetalleModuleModule { }
